import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getPhoenixStructuredData() {
  const url = "https://restorehair.com/locations/arizona/phoenix/";
  const description =
    "Find out about your hair transplant options in Phoenix with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("phoenix", url, description),
    locationPageCrumbs(url, "Phoenix"),
  ];
}
